import type { JoinSessionResponse, PendingSessionResponse, SessionRequestedPayload } from '../protocol';

export class CobrowseRelayError extends Error {
    public readonly sessionId: string;
    public readonly status: number;

    constructor(sessionId: string, status: number) {
        super(`Co-browsing relay answered ${status} for session ${sessionId}`);
        this.sessionId = sessionId;
        this.status = status;
    }
}

export class CobrowseRelayClient {
    private readonly relayUrl: string;

    constructor(relayUrl: string) {
        this.relayUrl = relayUrl;
    }

    async join(sessionId: string, authorization: string): Promise<JoinSessionResponse> {
        const response = await this.post(sessionId, 'join', authorization);

        return (await response.json()) as JoinSessionResponse;
    }

    async decline(sessionId: string, authorization: string): Promise<void> {
        await this.post(sessionId, 'decline', authorization);
    }

    async pending(authorization: string): Promise<SessionRequestedPayload | null> {
        const response = await fetch(new URL('/me/pending-session', this.relayUrl), { headers: { Authorization: authorization } }).catch(() => null);

        if (!response?.ok) {
            throw new CobrowseRelayError('pending', response?.status ?? 0);
        }

        return ((await response.json()) as PendingSessionResponse).request;
    }

    private async post(sessionId: string, action: 'join' | 'decline', authorization: string): Promise<Response> {
        const response = await fetch(new URL(`/sessions/${sessionId}/${action}`, this.relayUrl), {
            method: 'POST',
            headers: { Authorization: authorization },
        }).catch(() => null);

        if (!response?.ok) {
            throw new CobrowseRelayError(sessionId, response?.status ?? 0);
        }

        return response;
    }
}
